import axios, { type AxiosError, type AxiosResponse } from "axios";
import { toast } from "react-toastify";

const new_api_public = axios.create({
  baseURL: import.meta.env.VITE_APP_NEW_BACKEND_ENDPOINT,
  timeout: 1000 * 30,
  withCredentials: true,
});

// Auto-unwrap do envelope BaseController.ok ({ status, message, data })
// Mesma lógica de api.ts — backend-senne mistura envelope e jsonResponse direto.
// Detecta estritamente: precisa ter status:string + data + nenhum campo top-level fora do conjunto conhecido.
const ENVELOPE_KNOWN_KEYS = new Set(["status", "message", "data", "meta", "code"]);
function isEnvelope(raw: unknown): raw is { status: string; data: unknown } {
  if (!raw || typeof raw !== "object") return false;
  const obj = raw as Record<string, unknown>;
  if (typeof obj.status !== "string") return false;
  if (!("data" in obj)) return false;
  for (const key of Object.keys(obj)) {
    if (!ENVELOPE_KNOWN_KEYS.has(key)) return false;
  }
  return true;
}

new_api_public.interceptors.response.use(
  (response: AxiosResponse) => {
    if (isEnvelope(response.data)) {
      response.data = (response.data as { data: unknown }).data;
    }
    return Promise.resolve(response);
  },

  (error: AxiosError) => {
    if (!error.response) {
      toast.error("Falha na conexão com o servidor");
      return Promise.reject(error);
    }

    // Sem toast em 4xx: quem chamou mostra a mensagem do servidor na própria tela (login, código, cadastro).
    // O toast daqui vinha por cima dela dizendo só "Erro ao processar a requisição", porque o corpo é JSON,
    // e o 500 caía nos dois ramos e mostrava dois (P20EE-185, 2026-10-21).
    if (error.response.status >= 500 || error.response.status === 0) {
      toast.error("Falha ao processar a solicitação");
    }

    return Promise.reject(error);
  },
);

export default new_api_public;
